module.exports = __webpack_public_path__ + "static/media/location.2794beac.svg";